import { render, staticRenderFns } from "./NovaReserva.vue?vue&type=template&id=20336dab&"
import script from "./NovaReserva.vue?vue&type=script&lang=js&"
export * from "./NovaReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports